import React, { useEffect, useState } from "react";
import "./createPostFirst.css";
import Form from "react-bootstrap/Form";
import axios from "../../../../axios";
// import Select from "react-select";
import Select, { components } from "react-select";
import { createFilter } from "react-select";
import CreatableSelect from "react-select/creatable";
import { IP } from "../../../../internalServer";
import { toast } from "react-toastify";
import { X } from "lucide-react";
import assets from "../../../../assets/assets";

const CreatePostFirst = ({
  editingMode,
  clickPost,
  setClickPost,
  post,
  isInsideOfCommunity,
  communityData,
  setIsPostCreated,
  setAllPost,
  setPostCreatedCount,
  setChoosedCommunity,
  refetch1,
  setIsEdited,
  setIsPostCreated2,
  setReRenderPage,
}) => {
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [postTopicList, setPostTopicList] = useState([]);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [postAttach, setPostAttach] = useState([]);
  const [tagLimit, setTagLimit] = useState(false);
  const [attach, setAttach] = useState([]);
  const [attachmentSizes, setAttachmentSizes] = useState([]);

  const [editingPostImages, setEditingPostImages] = useState(post?.post_image);
  const [communities, setCommunities] = useState([]);
  const [isInProgress, setIsInProgress] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState({
    communityName: communityData
      ? communityData?.community_name
      : post?.community_id?.community_name
        ? post?.community_id?.community_name
        : null,
    communityProfilePicture: communityData
      ? communityData?.profile_picture
      : post?.community_id?.community_name
        ? post?.community_id?.profile_picture
        : null,
  });
  const { communityName, communityProfilePicture } = selectedCommunity;
  // const [selectedOptions, setSelectedOptions] = useState([]);

  const [postForm, setPostForm] = useState({
    title: "xploreSense",
    description: post?.description ? post?.description : null,
    community: post?.community_id?.id
      ? post?.community_id?.id
      : communityData?.id
        ? communityData?.id
        : null,
    topic: post?.tags ? post?.tags : [],
  });

  const { title, description, community, topic } = postForm;

  useEffect(() => {
    const getCommuntiy = async () => {
      await axios
        .get(`/api/v1/community/getByUserId/teacher/${teacher_id}`)
        .then((response) => {
          setCommunities(response.data.data);
        });

      await axios
        .get(`/api/v1/community/post/topic/getByUserId/teacher/${teacher_id}`)
        .then((response) => {
          const topicList = response.data.data.map((item, index) => {
            return {
              id: index,
              label: item.topic,
              value: item.topic,
            };
          });
          setPostTopicList(topicList);
        });
    };
    getCommuntiy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const imageHandler = async (e) => {
    let totalSize = postAttach.reduce((acc, file) => acc + file.size, 0);
    for (const file of e.target.files) {
      const isValidFile = validateFileType(file);
      const fileSizeOK = totalSize + file.size <= 10 * 1024 * 1024;
      const underLimit =
        editingPostImages && editingPostImages.length > 0
          ? editingPostImages.length < 5
          : attach.length < 5;
      if (fileSizeOK && isValidFile && underLimit) {
        if (file) {
          const formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadPostAttachment", file);
          try {
            const res = await axios.post(
              `/api/v1/community/post/uploadAttachment/userId/${teacher_id}`,
              formData,
            );

            if (editingPostImages && editingPostImages.length > 0) {
              const newImage = res?.data?.data;
              setEditingPostImages((prev) => [newImage, ...prev]);
              setAttachmentSizes((prev) => [
                ...prev,
                Math.round(file.size / 1024),
              ]);
            } else {
              setAttach((prev) => [...prev, res?.data?.data]);
              setAttachmentSizes((prev) => [
                ...prev,
                Math.round(file.size / 1024),
              ]);
            }
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        setIsValidFileType(false);
        return;
      }
    }
  };

  const handleDeleteAttachments = async (e, index, post) => {
    e.stopPropagation();
    if (editingPostImages && editingPostImages.length > 0) {
      setEditingPostImages(editingPostImages.filter((item, i) => i !== index));
    } else {
      setAttach((prev) => prev.filter((_, i) => i !== index));
    }
    try {
      let res = await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: post },
      });
      setIsValidFileType(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePostSubmit = async (e) => {
    e.preventDefault();
    setIsInProgress(true);
    let newPost = {
      user_id: teacher_id,
      title,
      description,
      tags: topic,
      post_image: attach,
      attachments_sizeKb: [Math.round(attachmentSizes / 1024)],
    };
    try {
      const res = await axios.post(
        `/api/v1/community/${community}/post/create`,
        newPost,
      );
      if (res) {
        setClickPost(false);
        setPostCreatedCount((prev) => prev + 1);
        setAllPost && setAllPost([]);
        setIsPostCreated((prev) => !prev);
        setReRenderPage(true);
        // window.location.reload();
      }

      // res && window.location.reload();
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const handlePostUpdate = async (e) => {
    e.preventDefault();
    setIsInProgress(true);
    let newPost = {
      user_id: teacher_id,
      title,
      description,
      tags: topic,
      post_image: editingPostImages,
      attachments_sizeKb: [Math.round(attachmentSizes / 1024)],
    };

    // if (postAttach) {
    //   let attachments = [];
    //   editingPostImages.forEach((image) => attachments.push(image));
    //   for (const post of postAttach) {
    //     const formData = new FormData();
    //     formData.append("name", post.name);
    //     formData.append("uploadPostAttachment", post);
    //     try {
    //       const res = await axios.post(
    //         `/api/v1/community/post/uploadAttachment/userId/${teacher_id}`,
    //         formData
    //       );
    //       // newPost.post_image = [res.data.data];
    //       attachments.push(res.data.data);
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    //   if (attachments.length > 0) {
    //     newPost.post_image = attachments;
    //   }
    // }

    try {
      const res = await axios.put(
        `/api/v1/community/${post?.community_id?.id}/post/update/${post?.id}`,
        newPost,
      );
      console.log(res);
      if (res) {
        toast.success(res?.data?.message);
        setClickPost(false);
        setIsEdited((prev) => !prev);
        setReRenderPage(true);
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };

  const handleInputChange = (inputValue) => {
    if (inputValue.length > 20) {
      inputValue = inputValue.substring(0, 20);
      setTagLimit(true);
    } else {
      setTagLimit(false);
    }
    setPostTopicList((prev) => [
      ...prev,
      { value: inputValue, label: inputValue },
    ]);
  };

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (
      !allowedExtensions.exec(filePath.name) ||
      filePath.size > 10 * 1024 * 1024
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}-${month}-${year}`;
    return outputDateString;
  };

  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setPostForm({ ...postForm, topic: selectedValues });
  };

  return (
    <>
      {clickPost && (
        <div className="create_post_transprant_body">
          <div className="create_post_container">
            <div className="">
              {/* <img
                src="/images/cross-circle3.svg"
                
                alt=""
                onClick={(e) => setClickPost(false)}
              /> */}
              <X
                className="create_post_close_btn p-1"
                onClick={(e) => {
                  setClickPost(false);
                }}
              />
              <div
                className="p-4"
                style={{ width: "100%", backgroundColor: "#fff0c5" }}
              >
                <div className=" d-flex justify-content-between create_post_header_container ">
                  {editingMode ? (
                    <div className="d-flex flex-column">
                      <span className=" create_post_header">Edit Post</span>
                      <span className="last_updated_post">
                        Last updated on {timeHelper(post?.updated_at)}
                      </span>
                    </div>
                  ) : (
                    <div className=" create_post_header">Create New Post</div>
                  )}

                  {(communityProfilePicture || communityName) && (
                    <div className="me-3">
                      <img
                        className="post_community_profile"
                        src={`${
                          communityProfilePicture
                            ? `${IP + communityProfilePicture}`
                            : "/images/channal pic3.svg"
                        }`}
                        alt=""
                        onError={(e) => {
                          e.target.src = "/images/channal pic3.svg";
                        }}
                      />
                      <span className="post_school_name">
                        &nbsp;{communityName}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className=" p-4 ">
                {!isInsideOfCommunity && !editingMode ? (
                  <select
                    onChange={(e) => {
                      setChoosedCommunity(e.target.value);
                      setPostForm({ ...postForm, community: e.target.value });
                      setSelectedCommunity({
                        communityName:
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "community-name",
                          ),
                        communityProfilePicture: e.target.options[
                          e.target.selectedIndex
                        ].getAttribute("community-profile-picture"),
                      });
                    }}
                    // className=" mt-4 addTopic"
                    className={` poppins-semibold
                    ${
                      communityName
                        ? " mt-3 form-select by"
                        : " mt-3 form-select bello1"
                    }
                  `}
                  >
                    <option>Select Channel</option>
                    {communities &&
                      communities?.length > 0 &&
                      communities?.map((community, index) => (
                        <option
                          key={index}
                          value={community.id}
                          community-name={community.community_name}
                          community-profile-picture={community.profile_picture}
                        >
                          {community.community_name}
                        </option>
                      ))}
                  </select>
                ) : (
                  <div className="slected_community_name mt-4">
                    {editingMode ? (
                      <span>{post?.community_id?.community_name}</span>
                    ) : (
                      <span>{communityData?.community_name}</span>
                    )}
                  </div>
                )}
                <div>
                  <div className="mt-4 addTopic">
                    <CreatableSelect
                      placeholder="Add Topic...."
                      options={postForm.topic.length >= 3 ? [] : postTopicList}
                      isMulti
                      value={postForm.topic.map((topic) => ({
                        value: topic,
                        label: topic,
                      }))}
                      onChange={handleChange}
                      isClearable
                      className="poppins-semibold"
                    />
                  </div>
                  <p className="tagsStyl">*Maximum 3 topics allowed.</p>
                </div>

                <textarea
                  type="text"
                  placeholder="Description"
                  className="w-100 post_text_field  poppins-semibold"
                  value={description}
                  maxLength={250}
                  onChange={(e) =>
                    setPostForm({ ...postForm, description: e.target.value })
                  }
                />

                <div
                  className=" file_attach_container orange-scrollBar  d-flex align-items-center"
                  style={{ overflowX: "auto" }}
                >
                  {attach?.length > 0 &&
                    attach.map((post, index) => (
                      <div
                        key={index}
                        className=" col-7 m-3  p-0 post_image_box1 "
                      >
                        <img
                          src={`${IP + post}`}
                          className="post_image1"
                          alt=""
                        />

                        <img
                          src="/images/cross-circle3.svg"
                          className=" post_image_close_btn"
                          alt=""
                          onClick={(e) =>
                            handleDeleteAttachments(e, index, post)
                          }
                        />
                      </div>
                    ))}

                  {editingPostImages &&
                    editingPostImages.length > 0 &&
                    editingPostImages.map((image, index) => (
                      <div
                        key={index}
                        className="col-7 m-3  p-0 post_image_box1"
                      >
                        <img
                          src={`${IP + image}`}
                          className="post_image1"
                          alt=""
                        />

                        <img
                          src="/images/cross-circle3.svg"
                          className=" post_image_close_btn"
                          alt=""
                          onClick={(e) =>
                            handleDeleteAttachments(e, index, image)
                          }
                        />
                      </div>
                    ))}
                </div>
                {tagLimit && (
                  <p className="SpclStyle">
                    Tag length exceeded, please enter a tag less than 20
                    Characters.
                  </p>
                )}
                <div className="create_post_footer mt-3  d-flex align-items-center justify-content-between">
                  <div className=" attach_section">
                    <input
                      type="file"
                      id="attachFile"
                      accept=".pdf,.jpg,.jpeg,.png"
                      multiple
                      style={{ display: "none" }}
                      onChange={imageHandler}
                    />
                    <label
                      htmlFor={`attachFile`}
                      style={{
                        border: "1px solid #8D4B28",
                        color: "#8D4B28",
                        backgroundColor: "white",
                      }}
                      className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold mt-2"
                    >
                      <img
                        src={assets.UploadIcon}
                        height="100%"
                        width="25px"
                        alt="Attach Icon"
                        style={{
                          objectFit: "contain",
                          cursor: "pointer",
                          maxHeight: "100%",
                        }}
                      />
                    </label>
                  </div>

                  {editingMode ? (
                    <button
                      onClick={handlePostUpdate}
                      disabled={isInProgress}
                      className="  btn btn-danger py-2 post_btn1 poppins-semibold"
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      onClick={handlePostSubmit}
                      disabled={
                        !description ||
                        !community ||
                        // !postAttach.length > 0 ||
                        isInProgress
                      }
                      className="  btn btn-danger px-4  post_btn1 poppins-semibold"
                    >
                      Post
                    </button>
                  )}
                </div>
                {!isValidFileType && (
                  <p id="errorMsg">
                    Please upload a file with a valid extension (JPG, JPEG, PNG)
                    and file size should be less then 10MB maximum 5 files
                    allowed.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreatePostFirst;
